import { render, staticRenderFns } from "./AssessmentReport.vue?vue&type=template&id=47de1990"
import script from "./AssessmentReport.vue?vue&type=script&lang=js"
export * from "./AssessmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports